import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { CdnIcon } from '@shared/ui';

interface Props {
	className?: string;
	errorText?: string | React.ReactNode;
	isShow?: boolean;
	children: React.ReactNode;
}

/**
 * @deprecated use the ServiceSummary component, which already has a check for product status (in ServiceSummaryOption component)
 */
const ServiceError: React.FC<Props> = ({ className, errorText, isShow, children }) => {
	const { ServiceError: css } = useTheme('CheckoutAdditionalService');
	const { t } = useTranslation('Cart');

	if (isShow) {
		return (
			<div className={cn(css.container, className)}>
				<div className={css.icon}>
					<CdnIcon icon="Info/Warning" />
				</div>
				{errorText ??
					t(
						'The service you have added cannot be activated. Try connecting later or contact the airline operator.'
					)}
			</div>
		);
	}

	return <>{children}</>;
};

export default ServiceError;
